import { IoLinkOutline } from "react-icons/io5";
import "./ExternalLink.css";

export default function ExternalLink({ href, buttonType = "none", children }) {
    return (
        <>
            {buttonType === "none" ?
                <a href={href} target="_blank" rel="noopener noreferrer">
                    <IoLinkOutline size={"1em"} style={{ paddingRight: "0.2em" }} />
                    {children}
                </a> :
                <div className={`external-link-${buttonType}-button`}>
                    <a href={href} target="_blank" rel="noopener noreferrer">
                        <IoLinkOutline size={"1em"} style={{ paddingRight: "0.2em" }} />
                        {children}
                    </a>
                </div>
            }
        </>
    )
}